import { render, staticRenderFns } from "./OrderRefundList.vue?vue&type=template&id=6cb28684&scoped=true&"
import script from "./OrderRefundList.vue?vue&type=script&lang=js&"
export * from "./OrderRefundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb28684",
  null
  
)

export default component.exports